import { useMutation } from "@tanstack/react-query";
import { WiMuleSQL } from "../../services/WiMuleSQL";
import toast from "react-hot-toast";
import { useContext } from "react";
import { UserContext } from "../../contexts/UserContext";

export const useUpdateExtended = () => {
  const { userDetails } = useContext(UserContext);
  // Early exit if no token is available
  if (!userDetails.userWiMuleToken) {
    throw new Error("Authentication token is missing.");
  }
  return useMutation({
    mutationFn: async (userData) => {
      const endpoint = `${WiMuleSQL}/api/Employee/UpdateExtendedData`;

      try {
        const response = await fetch(endpoint, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `bearer ${userDetails.userWiMuleToken}`,
          },
          body: JSON.stringify(userData),
        });

        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        }

        return await response.json();
      } catch (error) {
        throw new Error(error.message);
      }
    },
    onSuccess: (data) => {
      // Handle success
      toast.success(data.message || "User updated successfully");
    },
    onError: (error) => {
      // Handle error
      toast.error(error.message || "Failed to update user");
    },
  });
};
